import {IconEyeClosed, IconEyeOpen} from "@darwinex/components-library";
import React, {useState} from "react";
import {CommercialInfoCheckbox} from "src/components/auth/CommercialInfoCheckbox";
import {Button} from "src/components/common/button/Button";
import Input from "src/components/common/input/Input";
import classNames from "classnames";
import IconChevron from "src/components/icons/IconChevron";
import {useTranslationService} from "src/services/TranslationService";
import styles from "src/components/auth/Auth.module.scss"
import {isString} from "src/utils/common";
import ErrorForm from "../../common/input/ErrorForm";
import {Alert} from "../../common/alert/Alert";
import ErrorsRequest from "../../errors-request";
import {GeneralLoading} from "../../common/general-loading/GeneralLoading";

export const SignUpForm = ({
    affiliate,
    referredActive,
    errors,
    formSubmit,
    disabledSignUpButton,
    disabledRegulatedCompany,
    handleChange,
    handleChangeRegisterCountry,
    handleChangeRegulatedCompany,
    handleChangeAffiliate,
    usernameInput,
    usernameValue,
    usernameSuccess,
    usernameError,
    usernameErrorMsg,
    usernameWarning,
    emailInput,
    emailValue,
    emailSuccess,
    emailError,
    emailErrorMsg,
    emailWarning,
    passwordInput,
    passwordValue,
    passwordSuccess,
    passwordError,
    passwordErrorMsg,
    passwordWarning,
    commercialCommunicationsAcceptedInput,
    commercialCommunicationsAcceptedChecked,
    commercialCommunicationsAcceptedSuccess,
    commercialCommunicationsAcceptedError,
    commercialCommunicationsAcceptedErrorMsg,
    regulatedCompany,
    regulatedCompanies,
    registerCountry,
    registerCountries,
    showModalCompareRegulatedCompanies,
}) => {
    const {t} = useTranslationService();
    const [showPassword,setShowPassword] = useState(false);

    const iconSize = {width:16,height:16};
    const passwordVisibilityToggle = <span onClick={()=>setShowPassword(p=>!p)}>{showPassword ? <IconEyeClosed {...iconSize}/> :<IconEyeOpen {...iconSize}/>}</span>

    const countries = registerCountries.map(c => c.id);

    return <form className={styles.form}>
        <h1 className={styles.title}>{t("new-login.signup-form.title")}</h1>
        <div className="dx-mt-5">{t("new-login.signup-form.already-have-account")}</div>

        {errors && <Alert variant="danger" className="dx-mt-3"><ErrorsRequest errors={errors}/></Alert>}

        <div className={styles.input_group}>
            <label className={styles.label}>
                {t("new-login.signup-form.username.label")}
            </label>
            <Input
                ref={usernameInput}
                name="username"
                type={"text"}
                value={usernameValue}
                onChange={e => handleChange(e, usernameInput)}
                success={usernameSuccess}
                error={usernameError}
                warning={usernameWarning}
            />
            {isString(usernameErrorMsg) &&
                <p className={classNames("dx-mt-3 dx-mb-0", usernameWarning ? 'text-warning' : 'text-danger-dark')}>
                    <ErrorForm error={usernameErrorMsg} isKey/>
                </p>}
            <p className={styles.input_hint}>{t("new-login.signup-form.username.hint")}</p>
        </div>

        <div className={styles.input_group}>
            <label className={styles.label}>
                {t("new-login.signup-form.email.label")}
            </label>
            <Input
                ref={emailInput}
                name="email"
                type={"text"}
                value={emailValue}
                onChange={e => handleChange(e, emailInput)}
                success={emailSuccess}
                error={emailError}
                warning={emailWarning}
            />
            {isString(emailErrorMsg) &&
                <p className={classNames("dx-mt-3 dx-mb-0", emailWarning ? 'text-warning' : 'text-danger-dark')}>
                    <ErrorForm error={emailErrorMsg} isKey/>
                </p>}
        </div>

        <div className={styles.input_group}>
            <label className={styles.label}>
                {t("new-login.signup-form.password.label")}
            </label>
            <Input
                ref={passwordInput}
                name="password"
                type={showPassword?"text":"password"}
                value={passwordValue}
                onChange={e => handleChange(e, passwordInput)}
                success={passwordSuccess}
                error={passwordError}
                warning={passwordWarning}
                afterContent={passwordVisibilityToggle}

            />
            {isString(passwordErrorMsg) &&
                <p className={classNames("dx-mt-3 dx-mb-0", passwordSuccess ? 'text-success-dark' : (passwordWarning ? 'text-warning' : 'text-danger-dark'))}>
                    <ErrorForm error={passwordErrorMsg} isKey/>
                </p>}
            <p className={styles.input_hint}>{t("new-login.signup-form.password.hint")}</p>
        </div>

        <div className={classNames(styles.input_group, styles.has_2)}>
            <div>
                <label className={classNames(styles.label, 'text-nowrap')}>
                    {t("new-login.signup-form.country.label")}
                </label>
                <Input
                    type={"select"}
                    options={countries}
                    selectOptionsRenderer={(country) => country && registerCountries ? registerCountries.find(c => c.id === country).name : ''}
                    value={registerCountry}
                    onChange={e => handleChangeRegisterCountry(e)}
                    afterContent={<IconChevron rotation={"down"} className={""}/>}
                />
            </div>
            {!disabledRegulatedCompany && <div>
                <label className={classNames(styles.label, 'text-nowrap')}>
                    {t("new-login.signup-form.regulator-entity.label")}
                </label>
                <Input
                    type={"select"}
                    options={regulatedCompanies}
                    selectOptionsRenderer={(reg) => t(reg)}
                    value={regulatedCompany}
                    onChange={e => handleChangeRegulatedCompany(e)}
                    afterContent={<IconChevron rotation={"down"} className={""}/>}
                    disabled={regulatedCompanies.length < 2}
                />
            </div>}
        </div>
        { regulatedCompany !== null && !disabledRegulatedCompany && <p className={'dx-mt-7'}>{t(`new-login.disclaimer-${regulatedCompany}`)}</p>}
        { regulatedCompany !== null && !disabledRegulatedCompany && <p className={'dx-mt-3'}><a href="#" onClick={e => showModalCompareRegulatedCompanies(e)}>{t('new-login.disclaimer-meaning')}</a></p>}

        <div id='recaptcha-register'/>

        {affiliate && <>
            <div className={"dx-mt-7 theme-light"}>
                <Alert variant={"info"} icon={"info"}>
                    {t("new-login.signup-form.signup-with-affiliate", {affiliate})}
                </Alert>
            </div>
            <div className={"dx-mt-7"}>
            <label className={classNames(styles.label, "align-items-start")}>
                <Input
                    type={"checkbox"}
                    className={"flex-shrink-0"}
                    onChange={e => handleChangeAffiliate(e)}
                    checked={referredActive}
                />
                <span className={"dx-ml-3"}>{t("new-login.signup-form.reject-affiliate", {affiliate})}</span>
            </label>
        </div></>}

        {!disabledRegulatedCompany &&
            <CommercialInfoCheckbox
                className={'dx-my-7'}
                onClick={e => handleChange(e, commercialCommunicationsAcceptedInput)}
                regulatedCompany={regulatedCompany}
                input={commercialCommunicationsAcceptedInput}
                checked={commercialCommunicationsAcceptedChecked}
                success={commercialCommunicationsAcceptedSuccess}
                error={commercialCommunicationsAcceptedError}
                errorMsg={commercialCommunicationsAcceptedErrorMsg}
            />
        }

        {!disabledRegulatedCompany && <p className={'dx-mb-7'}>{t('new-login.disclaimer', {
            reg: regulatedCompany ? regulatedCompany.toLowerCase() : '',
        })}</p> }

        {regulatedCompany !== null && <>
            {regulatedCompany === ''
                ? <MissingRegCoAlert>{t("new-login.signup-form.cta.error")}</MissingRegCoAlert>
                : !disabledRegulatedCompany && <Button
                variant={"primary-dark"}
                className={"dx-font-size-md font-open-sans"}
                rounded
                onClick={e => {
                    formSubmit(e);
                }}
                disabled={disabledSignUpButton}
            >
                {!disabledSignUpButton ? t("new-login.signup-form.cta") : <GeneralLoading background={'#026dce'} circleFill={'#FFFFFF'} height={21} />}
            </Button>
            }
        </>}
    </form>
}

export const MissingRegCoAlert = ({children}) => (<div className={"dx-mt-7 dx-mb-5"}>
    <Alert variant="danger" className="dx-mt-3">{children}</Alert>
</div>)
